import React from "react";
import { Asset, Hotspot } from "../../../Types";
import IconSound from "../../Icons/IconSound";
import { getLanguageFile } from "../../common/GetLanguageFile";

const Audio = (props: { spot: Hotspot; AudioList: Asset[] }) => {
  return (
    <div className="hotspot waypoint">
      <IconSound
        height="3rem"
        width="3rem"
        stroke="#282828"
        strokeWidth="45px"
      />
      <p>
        {props.spot.isNew
          ? getLanguageFile("right_panel.new_audio")
          : props.spot.title ||
            props.AudioList?.find((one) => one.assetId === props.spot.target)
              ?.assetDescription ||
            getLanguageFile("right_panel.audio_name_error")}
      </p>
      {/* {spot.isNew && !spot.EDIT_POS && <p>Non salvato</p>}
    {!spot.isNew && !spot.EDIT_POS && (
      <>
      {spot.target &&
        tourData.scenes.find((one) => one.id === spot.target) ? (
          <p style={{ fontSize: ".85rem" }}>
          {tourData.scenes.find((one) => one.id === spot.target)!.title}
          </p>
          ) : (
            <p style={{ color: "red" }}>Scena mancante!</p>
            )}
            </>
            )}
            {!spot.isNew && !spot.target && (
              <p style={{ color: "red" }}>Scena Mancante!</p>
            )} */}
    </div>
  );
};

export default Audio;
